import classNames from 'classnames/bind';
import { MouseEventHandler, type AnchorHTMLAttributes } from 'react';
import { Link, type LinkProps as LinkProps } from 'react-router-dom';

import style from './StyledLink.module.sass';

const cx = classNames.bind(style);

type AnchorProps = AnchorHTMLAttributes<HTMLAnchorElement>;

export type StyledLinkProps = (LinkProps | AnchorProps) & {
  variant?: 'primary' | 'info' | 'danger';
  effectVariant?: 'default' | 'reverse' | 'none';
  onClick?: MouseEventHandler;
  dataMetric?: string;
};

export const StyledLink = ({
  className,
  effectVariant = 'default',
  variant = 'primary',
  dataMetric,
  onClick,
  ...restProps
}: StyledLinkProps) => {

  const linkClassName = cx('link', variant, className, {
    reverseEffect: effectVariant === 'reverse',
    default: effectVariant === 'default',
  });

  if ('to' in restProps) {
    return (
      <Link
        data-metric={dataMetric}
        onClick={onClick}
        className={linkClassName}
        {...restProps}
      />
    );
  }

  return (
    <a
      data-metric={dataMetric}
      className={linkClassName}
      onClick={onClick}
      {...restProps}
    />
  );
};
